import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminUsersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('user');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
